import { isNotNullOrUndefined } from '@weft/utils';
import React from 'react';
import type { FieldPath } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { ErrorNotification } from '../../../../../components/design/ErrorNotification/ErrorNotification';
import { useErrorNotificationAdapter } from '../../../../../components/design/ErrorNotification/hooks/use-error-notification-adapter';
import { useCreatePlanContext } from '../../../../../contexts/create-plan-context';
import { useFormErrorNotificationContext } from '../../../../../contexts/form-error-notification-context/form-error-notification-context';
import type { FormErrorField } from '../../../../../contexts/form-error-notification-context/form-error-notification-context-types/form-error-field';
import type { NewPlanForm } from '../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from '../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { DELAY_FOCUS } from './create-plan-error-notification-consts/delay-focus';

export const CreatePlanErrorNotification: React.FC = () => {
  const { setCreatePlanTab } = useCreatePlanContext();
  const { errorsFields, registerErrorCustomField, showErrorNotification, setShowErrorNotification } = useFormErrorNotificationContext<PlanInputForm, CreatePlanTab>();
  const { formState: { errors }, setFocus } = useFormContext<PlanInputForm, NewPlanForm>();

  const mappedErrors = useErrorNotificationAdapter(errorsFields.map(errorField => errorField.fieldPath), errors);

  registerErrorCustomField('productsValidation');

  return (
    <ErrorNotification
      open={showErrorNotification && mappedErrors.length > 0}
      errors={mappedErrors}
      description="Find and fix the errors before saving the plan"
      onGoTo={(fieldPath) => {
        const tab = getFieldPathTab(fieldPath as FieldPath<PlanInputForm>, errorsFields);
        if (isNotNullOrUndefined(tab)) {
          setCreatePlanTab(tab);
        }

        delayFocus(fieldPath as FieldPath<PlanInputForm>, setFocus);
      }}
      onClose={() => setShowErrorNotification(false)}
    />
  );
};

function getFieldPathTab(fieldPath: FieldPath<PlanInputForm>, errorsFields: FormErrorField<PlanInputForm, CreatePlanTab>[]): CreatePlanTab | undefined {
  return errorsFields.find((errorField) => errorField.fieldPath === fieldPath)?.tab;
}

function delayFocus(fieldPath: FieldPath<PlanInputForm>, setFocus: (fieldPath: FieldPath<PlanInputForm>) => void) {
  setTimeout(() => {
    setFocus(fieldPath);
  }, DELAY_FOCUS);
}